module.exports = "<div class=\"grid-item-fixed nav-item-text\">\n    <span class=\"label label-red clickable\" ng-click=\"subscriptionModal('case',home.currentCase.data)\" ng-show=\"home.currentCase.data.id && casePaymentExpired\">Read Only</span>\n    <span ng-show=\"home.currentCase.data.public\" class=\"label label-gold\">Public</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./project/directives/case-status/caseStatus.html
// module id = 828
// module chunks = 3